import axios from "axios";
import errorHandler from "../utils/errorHandler.js";
import {
    GET_PRE_SIGNED_URL,
    MEDIA_URL,
    UAC_URL,
    SEND_MESSAGE_URL,
    GET_AGENT_URL,
    USER_URL,
    TASK_URL,
    GET_TEAM_REPORT_URL,
    GET_MEMBERSHIP_REPORT_URL,
    OPPORTUNITY_URL,
    GET_TEAM_URL,
    GET_USER_REPORT_URL,
    GET_APPLICANT_REPORT_URL,
    GET_POST_STATS_URL,
    APPLICANT_URL,
    ASSIGNMENT_URL,
    SUBMISSION_URL,
    POLLING_STATION_URL,
    AI_PREVIEW_URL,
    AGENT_UAC_URL,
    GROUP_URL, SYNC_URL, GET_TEAM_SOCIAL_REPORT_URL, GET_USER_URL, GET_TEAM_USER_REPORT_URL, GET_PAGE_STATS_URL,
    GET_INTERNSHIP_REPORT_URL, INTERNSHIP_STATUS_URL
} from "../api";
import {ADMINISTRATIVE, TIME} from "../stores/app";

export const searchOrderNumber = () => {

}

export const admin = (method, data) => {
    return axios({method: method, url: UAC_URL, data: data}).then((response) => {
        return {
            payload: response.data.payload,
            error: false
        }
    }).catch((error) => {
        errorHandler(error, "top-right");
        return {
            payload: null,
            error: true
        }
    });
}

export const agent = (method, data) => {
    return axios({method: method, url: AGENT_UAC_URL, data: data}).then((response) => {
        return {
            payload: response.data.payload,
            error: false
        }
    }).catch((error) => {
        errorHandler(error, "top-right");
        return {
            payload: null,
            error: true
        }
    });
}

export const group = (method, data) => {
    return axios({method: method, url: GROUP_URL, data: data}).then((response) => {
        return {
            payload: response.data.payload,
            error: false
        }
    }).catch((error) => {
        errorHandler(error, "top-right");
        return {
            payload: null,
            error: true
        }
    });
}

export const polling = (method, data) => {
    return axios({method: method, url: POLLING_STATION_URL, data: data}).then((response) => {
        return {
            payload: response.data.payload,
            error: false
        }
    }).catch((error) => {
        errorHandler(error, "top-right");
        return {
            payload: null,
            error: true
        }
    });
}

export const user = (method, data) => {
    return axios({method: method, url: USER_URL, data: data}).then((response) => {
        return {
            payload: response.data.message,
            error: false
        }
    }).catch((error) => {
        errorHandler(error, "top-right");
        return {
            payload: null,
            error: true
        }
    });
};

export const submission = (method, data) => {
    return axios({method: method, url: SUBMISSION_URL, data: data}).then((response) => {
        return {
            payload: response.data.payload,
            error: false
        }
    }).catch((error) => {
        errorHandler(error, "top-right");
        return {
            payload: null,
            error: true
        }
    });
}

export const opportunity = (method, data) => {
    return axios({method: method, url: OPPORTUNITY_URL, data: data}).then((response) => {
        return {
            payload: response.data.message,
            error: false
        }
    }).catch((error) => {
        errorHandler(error, "top-right");
        return {
            payload: null,
            error: true
        }
    });
};

export const getInternshipReport = () => {
    return axios.get(GET_INTERNSHIP_REPORT_URL).then((response) => {
        return {
            payload: response.data,
            error: false
        };
    }).catch((error) => {
        errorHandler(error, "top-right");
        return {
            payload: error,
            error: true
        }
    });
};

export const applicant = (method, data) => {
    return axios({method: method, url: APPLICANT_URL, data: data}).then((response) => {
        return {
            payload: response.data.message,
            error: false
        }
    }).catch((error) => {
        errorHandler(error, "top-right");
        return {
            payload: null,
            error: true
        }
    });
};

export const assignment = (method, data) => {
    return axios({method: method, url: ASSIGNMENT_URL, data: data}).then((response) => {
        return {
            payload: response.data.payload,
            error: false
        }
    }).catch((error) => {
        errorHandler(error, "top-right");
        return {
            payload: null,
            error: true
        }
    });
}

export const aiPreview = (method, data) => {
    return axios({method: method, url: AI_PREVIEW_URL, data: data}).then((response) => {
        return {
            payload: response.data.payload,
            error: false
        }
    }).catch((error) => {
        errorHandler(error, "top-right");
        return {
            payload: null,
            error: true
        }
    });
}

export const task = (method, data) => {
    return axios({method: method, url: TASK_URL, data: data}).then((response) => {
        return {
            payload: response.data.payload,
            error: false
        }
    }).catch((error) => {
        errorHandler(error, "top-right");
        return {
            payload: null,
            error: true
        }
    });
}

export const updateInternshipStatus = (data) => {
    return axios.put(INTERNSHIP_STATUS_URL, data).then((response) => {
        return {
            error: false,
            payload: response.data.payload
        }
    }).catch((error) => {
        errorHandler(error, "top-right");
        return {
            payload: null,
            error: true
        }
    });
};

export const message = (data) => {
    return axios.post(SEND_MESSAGE_URL, data).then((response) => {
        return {
            error: false,
            payload: response.data
        }
    }).catch((error) => {
        errorHandler(error, "top-right");
        return {
            payload: error,
            error: true
        }
    });
}

export const getUserReport = () => {
    return axios.get(GET_USER_REPORT_URL).then((response) => {
        return {
            payload: response.data,
            error: false
        };
    }).catch((error) => {
        errorHandler(error, "top-right");
        return {
            payload: error,
            error: true
        }
    });
};

export const applicantStats = (id) => {
    return axios.get(GET_APPLICANT_REPORT_URL(id)).then((response) => {
        return {
            payload: response.data,
            error: false
        };
    }).catch((error) => {
        errorHandler(error, "top-right");
        return {
            payload: error,
            error: true
        }
    });
};

export const getPostStat = (id) => {
    return axios.get(GET_POST_STATS_URL(id)).then((response) => {
        return {
            payload: response.data.payload,
            error: false
        };
    }).catch((error) => {
        errorHandler(error, "top-right");
        return {
            payload: error,
            error: true
        }
    });
};

export const getAgent = (id) => {
    return axios.get(GET_AGENT_URL(id)).then((response) => {
        return {
            payload: response.data,
            error: false
        }
    }).catch((error) => {
        errorHandler(error, "top-right");
        return {
            payload: null,
            error: true
        }
    });
}

export const getTeam = (id) => {
    return axios.get(GET_TEAM_URL(id)).then((response) => {
        return {
            payload: response.data,
            error: false
        }
    }).catch((error) => {
        errorHandler(error, "top-right");
        return {
            payload: null,
            error: true
        }
    });
}

export const getUser = (id) => {
    return axios.get(GET_USER_URL(id)).then((response) => {
        return {
            payload: response.data,
            error: false
        }
    }).catch((error) => {
        errorHandler(error, "top-right");
        return {
            payload: null,
            error: true
        }
    });
}

export const teamReport = (id) => {
    return axios.get(GET_TEAM_REPORT_URL(id)).then((response) => {
        return {
            payload: response.data,
            error: false
        }
    }).catch((error) => {
        errorHandler(error, "top-right");
        return {
            payload: null,
            error: true
        }
    });
}

export const getPageStat = (id) => {
    return axios.get(GET_PAGE_STATS_URL(id)).then((response) => {
        return {
            payload: response.data.payload,
            error: false
        };
    }).catch((error) => {
        errorHandler(error, "top-right");
        return {
            payload: error,
            error: true
        }
    });
};

export const userReport = (id) => {
    return axios.get(GET_TEAM_USER_REPORT_URL(id)).then((response) => {
        return {
            payload: response.data,
            error: false
        }
    }).catch((error) => {
        errorHandler(error, "top-right");
        return {
            payload: null,
            error: true
        }
    });
}

export const teamSocialReport = (id) => {
    return axios.get(GET_TEAM_SOCIAL_REPORT_URL(id)).then((response) => {
        return {
            payload: response.data,
            error: false
        }
    }).catch((error) => {
        errorHandler(error, "top-right");
        return {
            payload: null,
            error: true
        }
    });
}

export const getPreSignedUrl = () => {
    return axios.get(GET_PRE_SIGNED_URL).then((response) => {
        return {
            error: false,
            payload: response.data
        }
    }).catch((error) => {
        errorHandler(error, "top-right");
        return {
            payload: error,
            error: true
        }
    });
}

// export const uploadPhoto = (signed_url, binary, config) => {
//     return fetch(signed_url, {
//         method: 'PUT',
//         body: binary,
//         headers: config,
//     }).then(response => {
//         return {
//             payload: response,
//             error: false
//         }
//     }).catch(error => {
//         errorHandler(error, "top-right");
//         return {
//             payload: error,
//             error: true
//         }
//     });
// }
export const uploadPhoto = (signed_url, binary, headers, onProgress) => {
    return new Promise((resolve, reject) => {
        const xhr = new XMLHttpRequest();

        xhr.open("PUT", signed_url, true);

        Object.entries(headers).forEach(([key, value]) => {
            xhr.setRequestHeader(key, value);
        });

        // ✅ Progress logging
        xhr.upload.onprogress = (event) => {
            if (event.lengthComputable && onProgress) {
                const percent = Math.round(
                    (event.loaded / event.total) * 100
                );
                onProgress(percent); // ← console.log happens here
            }
        };

        xhr.onload = () => {
            if (xhr.status >= 200 && xhr.status < 300) {
                resolve({
                    payload: { url: signed_url },
                    error: false
                });
            } else {
                reject({ error: true });
            }
        };

        xhr.onerror = () => reject({ error: true });

        xhr.send(binary);
    });
};

export const getMembershipReport = () => {
    return axios.get(GET_MEMBERSHIP_REPORT_URL).then((response) => {
        return {
            payload: response.data,
            error: false
        };
    }).catch((error) => {
        errorHandler(error, "top-right");
        return {
            payload: error,
            error: true
        }
    });
};

export const media = (method, data) => {
    return axios({method: method, url: MEDIA_URL, data: data}).then((response) => {
        return {
            payload: response.data.message,
            error: false
        }
    }).catch((error) => {
        errorHandler(error, "top-right");
        return {
            payload: null,
            error: true
        }
    });
};

export const sync = () => {
    return function(dispatch) {
        return axios.get(SYNC_URL).then(async(response) => {
            await Promise.all([
                await dispatch(ADMINISTRATIVE({administrative: response.data.administrative})),
                await dispatch(TIME({time: response.data.time}))
            ]);

            return {
                error: false
            }
        }).catch((error) => {
            return errorHandler(error);
        });
    }
}
